import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Note: ``pl-3 pr-3`` instead of ``px-3`` so callers that
          // override only one side (e.g. ``pl-10`` for a leading
          // search icon) actually win the merge. With ``px-3``,
          // tailwind-merge v3 keeps both ``px-3`` and ``pl-10`` in
          // the output and Tailwind v4's cascade resolves ``px-3``
          // last → the icon overlaps the placeholder text. Splitting
          // into individual sides makes the conflict explicit.
          "flex h-10 w-full rounded-md border border-[var(--input-border)] bg-[var(--input-bg)] text-[var(--text-color)] pl-3 pr-3 py-2 text-sm file:border-0 file:bg-[var(--surface-secondary)] file:text-[var(--text-color)] file:text-sm file:font-medium file:mr-3 file:px-3 file:py-1 file:rounded-md placeholder:text-[var(--text-secondary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }